import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Send, List, PlusCircle } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import Layout from '../components/Layout';

// Import des composants existants
import SendRCS from './SendRCS';
import Campaigns from './Campaigns';

export default function RCSCampaign() {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'send';

  const handleTabChange = (value) => {
    setSearchParams({ tab: value });
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="rcs-campaign-page">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
              <Send className="h-7 w-7 text-indigo-600" />
              Campagnes RCS
            </h1>
            <p className="text-slate-500 mt-1">
              Créez et gérez vos campagnes de messagerie RCS
            </p>
          </div>
        </div>

        {/* Tabs */}
        <Tabs value={defaultTab} onValueChange={handleTabChange} className="w-full">
          <TabsList className="grid w-full max-w-md grid-cols-2 mb-6">
            <TabsTrigger value="send" className="flex items-center gap-2" data-testid="tab-send">
              <PlusCircle className="h-4 w-4" />
              Nouvelle Campagne
            </TabsTrigger>
            <TabsTrigger value="list" className="flex items-center gap-2" data-testid="tab-list">
              <List className="h-4 w-4" />
              Mes Campagnes
            </TabsTrigger>
          </TabsList>

          <TabsContent value="send" className="mt-0">
            <SendRCS embedded={true} />
          </TabsContent>

          <TabsContent value="list" className="mt-0">
            <Campaigns embedded={true} />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
